import type { Time } from "@suse-o11y/date-time/time";
import { type Signal, useMonitor } from "@suse-o11y/signal";
import React from "react";

import { SpecificRange, type TimeRange } from "../../app/state/view/timeline/TimeRange";
import type { MonitorCheckStatusHealthChange } from "../../common/openapi";
import { Timeline, TimelineHealthState, TimelineTimeTicks } from "../_timeline";

interface HealthTimelineChartProps {
	disabled?: boolean;
	timestamp: Signal<undefined | Time>;
	timeRange: Signal<TimeRange>;
	health: undefined | ReadonlyArray<MonitorCheckStatusHealthChange>;
}

export const HealthTimelineChart: React.FC<HealthTimelineChartProps> = React.memo(
	({ disabled, timestamp, timeRange, health }) => {
		const monitor = useMonitor();

		return (
			<Timeline
				brush={{
					areaOffsetTop: 20,
					areaOffsetBottom: 5,
					onBrush: (left, right) => timeRange.write(new SpecificRange(left, right)),
				}}
				data-testid="health-timeline-chart"
				disabled={disabled || health == null}
				height={50}
				hideTopologyTimeMarker
				onClick={(time) => timestamp.write(time)}
				timeRange={timeRange.read(monitor)}
				timestamp={timestamp.read(monitor)}
			>
				<TimelineTimeTicks withTicks y={14} />
				<TimelineHealthState health={health} y={32} />
			</Timeline>
		);
	},
);
